import React from "react";
import accounting from "accounting";

function Usages({ usages }) {
  return (
    <div className="w-full flex flex-col p-5 gap-1 rounded-lg  text-gray-900 shadow-gray-700  text-base 2xl:text-[1.1vw] 2xl:leading-[1.1vw]">
      <h6 className="font-semibold text-xl 2xl:text-[1.3vw] 2xl:leading-[1.3vw] text-black  mb-4  ">
        Usage
      </h6>
      <div className="w-full h-[0.5px] rounded-xl mb-3 bg-black "></div>
      <div className="text-slate-700 flex gap-2">
        <span>Credits consumed:</span>{" "}
        <strong className="tracking-wider	">
          {accounting.formatNumber(
            usages?.total_credits - usages?.credits_limit
          )}
        </strong>
      </div>
      <div className="text-slate-700 flex gap-2">
        <span>Subscription limit: </span>
        <strong className="tracking-wider	">
          {accounting.formatNumber(usages?.total_credits)}
        </strong>
      </div>
      <div className="text-sm min-[1500]:text-xl 2xl:text-[1.1vw] 2xl:leading-[1.1vw] text-slate-600">
        Your credits renew at the start of every calendar month but your extra
        credits will remain as it is.
      </div>
      <div className="text-slate-700 flex gap-2">
        <span>Next renewal: </span>

        {usages?.create_expire ? (
          <span>
            <strong className="tracking-wider	">
              {new Intl.DateTimeFormat("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
              }).format(new Date(usages.create_expire))}
            </strong>
          </span>
        ) : (
          <span>Not available</span>
        )}
      </div>
    </div>
  );
}

export default Usages;
